// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3gggD","calendarButtons":"ClockData_calendarButtons__LQ-8t"};